import classNames from "classnames/bind";
import styles from "./LiveVideo.module.css";
import PlayerItem from "../../../../../LiveCamera/Camera/StreamCam/PlayerItem";
import React, { useContext, useState } from "react";
import SettingCamera from "../../../../../LiveCamera/Camera/StreamCam/SettingCamera";
import streamingClient from "../../../../../../services/streamingClient";
import { Toast } from "../../../../../../components";
import RenameCamera from "../../../../../LiveCamera/Camera/RenameCamera/RenameCamera";
import { cameraManagement } from "../../../../../../services/api/cameraManagementApi";
import { LisencePlateContext } from "../../../../../../contexts";

const cx = classNames.bind(styles);

const LiveVideo = ({ data }) => {
    const { isFullScreen, setIsFullScreen } = useContext(LisencePlateContext);
    const [isShowOptions, setIsShowOptions] = useState(false);
    const [showInfoCamera, setShowInfoCamera] = useState(false);
    const [restartCamera, setRestartCamera] = useState(false);
    const [showSettingModal, setShowSettingModal] = useState(false);
    const [reNameCamera, setReNameCamera] = useState({
        name: '',
        code: null,
        show: false
    });
    const [isSearchCam, setIsSearchCam] = useState(false);
    const [refresh, setRefresh] = useState(false)
    const handleScreen = () => {
        setIsFullScreen(!isFullScreen)
    }

    const handleShowOptions = () => {
        setIsShowOptions(!isShowOptions)
    }

    const handleShowRename = () => {

    }

    const handleShowInfoCamera = () => {

    }
    const handleShowSettingCamera = () => {

    }
    const handleShowChangeName = (e) => {
        // console.log(e);
        setReNameCamera({
            show: !!e,
            name: e.name,
            code: e.code
        })
    }

    const handleChangeNameCamera = (e) => {
        // console.log(e);
    }

    const handleRestartCamera = async (code) => {
        try {
            await streamingClient.post("/streamManagement/post-restart-streaming/", {
                camera_id: code,
            });
            Toast.open("Khởi động lại thành công", "success");
        } catch (error) {
            Toast.open("Vui lòng thử lại sau vài phút", "danger");
        }
    };

    const handleSubmitNameCamera = async () => {
        try {
            const res = await cameraManagement.reName(
                { camera_name: reNameCamera.name },
                reNameCamera.code
            );
            if (res.result) {
                Toast.open("Chỉnh sửa thành công", "success");
            }
        } catch (e) {
            Toast.open("Sửa tên camera không thành công", "danger");
        }
    };
    return (
        <div className={cx('container')}>
            <div className={cx('nor-screen', isFullScreen && 'fullscreen')}>
                <PlayerItem item={data} handleFullScreen={handleScreen} nfc={[]} screen={0} showOptions={handleShowOptions} />
                {isShowOptions && (
                    <SettingCamera
                        show={isShowOptions}
                        item={data}
                        code={data?.code}
                        refresh={refresh}
                        showInfoCamera={handleShowInfoCamera}
                        showSettingModal={handleShowSettingCamera}
                        restartCamera={handleRestartCamera}
                        onShowRename={handleShowRename}
                        setNameCamera={handleShowChangeName}
                        isSearchCam={isSearchCam}
                    />
                )}
                {reNameCamera?.show &&
                    <div className={cx("modal-detail")}>
                        <RenameCamera
                            nameCamera={reNameCamera.name}
                            setNameCamera={handleChangeNameCamera}
                            handleClose={handleShowChangeName}
                            reNameCamera={handleSubmitNameCamera}
                        />
                    </div>}
            </div>
        </div>
    )
}

export default LiveVideo;